import React from 'react'
import './firstFiftyOnboarding.css'
import { useEffect } from 'react'

function MainContent() {
    useEffect(() => {
        // Ensure Calendly script is loaded
        if (
          !document.querySelector(
            'script[src="https://assets.calendly.com/assets/external/widget.js"]'
          )
        ) {
          const script = document.createElement("script");
          script.src = "https://assets.calendly.com/assets/external/widget.js";
          script.async = true;
          document.body.appendChild(script);
        }
    }, []);
  return (
    <section className="home landing" id="first-fifty-onboarding-banner">
        <div className="row ">
            <div className="container">
                <div className="banne-wrap  wow zoomIn">
                        <img src="/images/firstFifty-images/landing-logo-big-img.png" alt="Welcome to the 1st Fifty" />
                        <h1>Welcome to the <span className="red">1st Fifty</span></h1>
                        <p>We’re excited to have you on board. Let’s schedule a call to answer your questions, learn about your goals, and explore how Snapshot Videos can best serve your organization.</p>
                </div>
                {/* Calendly inline widget begin */}
                <div className="calendly-inline-widget" data-url="https://calendly.com/jimwacksman/snapshot-videos-discussion"></div>
                {/* <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script> */}
                {/* Calendly inline widget end */}
            </div>	
        </div>
    </section>
  )
}

export default MainContent